import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicamentosInner } from '@app/core/services/api/model/medicamentosInner';

@Component({
  selector: 'app-modal-detail-drug',
  templateUrl: './modal-detail-drug.component.html',
  styleUrls: ['./modal-detail-drug.component.scss']
})
export class ModalDetailDrugComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ModalDetailDrugComponent>, @Inject(MAT_DIALOG_DATA) public data: MedicamentosInner) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }
}
